import { Link } from 'react-router-dom';
import { getFeaturedComics } from '@/mocks/comics';

export default function FeaturedSection() {
  const featured = getFeaturedComics();

  return (
    <section id="featured" className="py-16 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block px-4 py-1 rounded-full bg-primary-100 text-primary-600 text-xs font-medium mb-4">
            编辑精选
          </span>
          <h2
            className="text-2xl md:text-4xl font-bold text-foreground-950"
            style={{ fontFamily: 'var(--font-heading)' }}
          >
            热门推荐
          </h2>
          <p className="mt-3 text-foreground-600 text-sm md:text-base max-w-xl mx-auto">
            精选优质韩国漫画，口碑爆棚的必读佳作，每一部都值得细细品味
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {featured.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group block"
              data-product-shop
            >
              <div className="relative overflow-hidden rounded-lg aspect-[3/4] mb-3">
                <img
                  src={comic.coverUrl}
                  alt={comic.title}
                  title={`${comic.title} - 免费韩国漫画在线阅读`}
                  className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/70 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 flex items-end p-3">
                  <span className="text-white text-xs bg-primary-500 px-2 py-1 rounded-full whitespace-nowrap">
                    {comic.status}
                  </span>
                </div>
                <div className="absolute top-2 right-2 bg-black/60 text-white text-xs px-2 py-1 rounded-full flex items-center gap-1">
                  <i className="ri-star-fill text-yellow-400 text-xs"></i>
                  {comic.rating}
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 truncate group-hover:text-primary-500 transition-colors">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500 mt-1">{comic.author}</p>
            </Link>
          ))}
        </div>

        <div className="text-center mt-10">
          <Link
            to="/category/romance"
            className="inline-flex items-center gap-2 px-6 py-2.5 rounded-full border border-background-300 text-foreground-700 text-sm font-medium hover:border-primary-400 hover:text-primary-500 transition-all duration-300 whitespace-nowrap"
          >
            查看更多热门漫画
            <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}